import {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle
} from 'react'

const Altcha = forwardRef(({ onStateChange }, ref) => {
  const widgetRef = useRef(null)
  const [value, setValue] = useState(null)

  useImperativeHandle(ref, () => ({
    get value() {
      return value
    }
  }), [value])

  useEffect(() => {
    const handleStateChange = (ev) => {
      if (ev?.detail) {
        setValue(ev.detail.payload || null)
        onStateChange?.(ev)
      }
    }

    const current = widgetRef.current
    if (!current) return

    current.addEventListener('statechange', handleStateChange)

    return () => {
      current.removeEventListener('statechange', handleStateChange)
    }
  }, [onStateChange])

  return (
    <altcha-widget
      ref={widgetRef}
      configuration={JSON.stringify({
        debug: true,
        test: true
      })}
    />
  )
})

export default Altcha